import React from 'react';
import { ColumnParams } from '../ColumnTemplate';

const ButtonColumn = (props: ColumnParams) => {
    return <button onClick={() => props.action(props.value, props.row)}>Button</button>;
};

export default ButtonColumn;